
import { Component, Prop, Vue } from "vue-property-decorator";
import { SMAdditionalInfo, SMUser } from "@/store";

import ServiceBlock from "@/components/V2/ServiceSection/ServiceBlock.vue";
import ServiceSection from "@/components/V2/ServiceSection/ServiceSection.vue";
import ServiceCounter from "@/components/V2/ServiceSection/ServiceCounter.vue";

@Component({
  components: {
    ServiceSection,
    ServiceBlock,
    ServiceCounter,
  },
})
export default class HomePageVisaSection extends Vue {
  @Prop({ type: Object }) readonly src;

  title = "Visas";

  get sectionProps() {
    const { title } = this;

    return {
      title,
    };
  }

  get counters() {
    const { actions_to_do, applications_in_progress } = this.src.visas;

    return [
      {
        label: "Actions to do",
        icon: "list-check",
        value: actions_to_do ?? 0,
        buttonLabel: "View",
        show: actions_to_do > 0,
        action: this.goToCandidates,
      },
      {
        label: "Applications in progress",
        icon: "hourglass",
        value: applications_in_progress ?? 0,
        buttonLabel: "View",
        show: applications_in_progress > 0,
        action: this.goToCandidates,
      },
    ];
  }

  goToCandidates() {
    this.$router.push("/employer/visa-cases");
  }

  texts = {
    hasSl:
      "Get started by preparing the required documents and following step-by-step guidance to submit the application confidently",
    hasNoSl: "Visa applications will unlock as soon as you obtain your Sponsor Licence",
  };

  get actualSlText() {
    return SMUser.isSponsor ? this.texts.hasSl : this.texts.hasNoSl;
  }

  get showValidateCandidate() {
    if (SMUser.isSponsor) return false;

    return SMUser.isSLStarted;
  }

  get blocks() {
    return [
      {
        title: "Start Skilled Worker Visa Application",
        text: this.actualSlText,
        buttonLabel: "Start",
        action: this.startSW,
        icon: "pencil",
        disabled:
          !SMUser.isSponsor || !this.src?.banner?.employer_completed_account_setup_onboarding,
        show: true,
        swCounter: SMUser.prepaidCosSW,
      },
      {
        title: "Validate Candidate",
        text: SMUser.isSponsor
          ? "You can already validate candidates you may want to sponsor"
          : "You can already validate potential candidates you may want to sponsor once you obtain your Sponsor Licence",
        buttonLabel: "Let’s check",
        action: this.validateCandidate,
        icon: "clock",
        disabled: false,
        show: !SMAdditionalInfo.isOnboardingCompleted,
      },
    ];
  }

  startSW() {
    SMAdditionalInfo.startSWQuickAction();
  }

  validateCandidate() {
    SMAdditionalInfo.inviteCandidate();
  }

  get testUser() {
    return SMUser.isSponsor + " - " + SMUser.isSLStarted;
  }
}
